/**
 * Homepage Hero Search — thin shell using GstarSearchCore.
 * Handles only: Hero DOM bindings, hp-hero__* CSS classes, rendering.
 */
(function () {
  'use strict';

  var _collectionFlagMap = { japan: 'jp', korea: 'kr', thailand: 'th', singapore: 'sg', vietnam: 'vn', indonesia: 'id', malaysia: 'my', philippines: 'ph', taiwan: 'tw', china: 'cn', india: 'in', australia: 'au', 'new zealand': 'nz', europe: '_globe_eu', uk: 'gb', usa: 'us', 'united states': 'us', uae: 'ae', egypt: 'eg', turkey: 'tr', brazil: 'br', africa: '_globe_af', asia: '_globe_as', oceania: '_globe_oc', 'north america': '_globe_na', 'south america': '_globe_sa' };

  function init() {
    var C = window.GstarSearchCore;
    if (!C) return;

    var input = document.querySelector('[data-hp-search-input]');
    if (!input) return;

    var container = document.querySelector('[data-hp-search-results]');
    var list = document.querySelector('[data-hp-results-list]');
    var footer = document.querySelector('[data-hp-results-footer]');
    var footerLink = document.querySelector('[data-hp-results-link]');
    var clearBtn = document.querySelector('[data-hp-search-clear]');
    var form = input.closest('form');
    var debounceTimer = null;
    var activeIndex = -1;
    var fetchIdRef = { id: 0 };

    function open() { if (container) container.classList.add('is-open'); }
    function close() { if (container) container.classList.remove('is-open'); activeIndex = -1; }

    /* ---- Render helpers ---- */
    function arrow() {
      return '<svg class="hp-hero__result-arrow" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';
    }

    function renderDestItem(dest, query) {
      var priceHtml = C.priceCache[dest.name]
        ? C.i18n('priceFrom', { price: C.priceCache[dest.name] })
        : '<span style="color:#94a3b8;">' + C.i18n('browseCollection') + '</span>';
      var typeLabel = dest.type === 'region' ? '<span class="hp-hero__region-badge">Region</span>' : '';
      return '<a href="' + C.localizeUrl(C.resolveDestUrl ? C.resolveDestUrl(dest.url) : dest.url) + '" class="hp-hero__result-item">' +
        '<div class="hp-hero__result-image" style="display:flex;align-items:center;justify-content:center;background:none;">' + C.renderFlag(dest.flag, 28) + '</div>' +
        '<div class="hp-hero__result-info"><p class="hp-hero__result-title">' + (query ? C.highlightMatch(dest.name, query) : C.escapeHtml(dest.name)) + typeLabel + '</p><p class="hp-hero__result-price">' + priceHtml + '</p></div>' +
        arrow() + '</a>';
    }

    function renderCoverageItem(p, query) {
      var flagCode = C.getFlagForProduct(p.t) || C.getFlagForHandle(p.h);
      if (!flagCode) {
        var tl = (p.t || '').toLowerCase();
        if (/europe|欧洲|歐洲/.test(tl)) flagCode = '_globe_eu';
        else if (/asia|亚洲|亞洲|东南亚|東南亞|southeast asia|south east asia|アジア/.test(tl)) flagCode = '_globe_as';
        else if (/africa|非洲/.test(tl)) flagCode = '_globe_af';
        else if (/middle east|中东|中東/.test(tl)) flagCode = '_globe';
        else if (/global|全球|worldwide|world/.test(tl)) flagCode = '_globe';
        else if (/caucasus|central asia|中亚|中亞/.test(tl)) flagCode = '_globe';
      }
      // Handle-based fallback when title is in a language we didn't match above
      if (!flagCode && p.h) {
        var hl = p.h.toLowerCase();
        if (hl.indexOf('southeast-asia') > -1 || hl.indexOf('asia-explorer') > -1 || hl.indexOf('south-asia') > -1) flagCode = '_globe_as';
        else if (hl.indexOf('europe') > -1) flagCode = '_globe_eu';
        else if (hl.indexOf('africa') > -1) flagCode = '_globe_af';
        else if (hl.indexOf('global') > -1 || hl.indexOf('worldwide') > -1) flagCode = '_globe';
        else if (hl.indexOf('middle-east') > -1) flagCode = '_globe';
        else if (hl.indexOf('central-asia') > -1) flagCode = '_globe';
      }
      var imgHtml;
      if (flagCode) {
        imgHtml = C.renderFlag(flagCode, 36);
      } else if (p.i) {
        imgHtml = '<img src="' + p.i + '" alt="" style="width:36px;height:36px;object-fit:cover;border-radius:50%;" loading="lazy">';
      } else {
        imgHtml = '<span style="font-size:1.5rem;line-height:1;">🌍</span>';
      }
      var coverageLabel = p.c === 1 ? '' : '<span class="hp-hero__region-badge">' + C.i18n('nCountries', { count: p.c }) + '</span>';
      return '<a href="' + C.localizeUrl('/products/' + p.h) + '" class="hp-hero__result-item">' +
        '<div class="hp-hero__result-image" style="' + (flagCode ? 'border-radius:50%;overflow:hidden;width:36px;height:36px;flex-shrink:0;' : '') + '">' + imgHtml + '</div>' +
        '<div class="hp-hero__result-info"><p class="hp-hero__result-title">' + (query ? C.highlightMatch(p.t, query) : C.escapeHtml(p.t)) + coverageLabel + '</p><p class="hp-hero__result-price">' + C.i18n('priceFrom', { price: C.currencySymbol + (p.p / 100).toFixed(2) }) + '</p></div>' +
        arrow() + '</a>';
    }

    function renderResults(dests, articles, query, isPopular, coverage) {
      var hasDests = dests && dests.length > 0;
      var hasArts = articles && articles.length > 0;
      var hasCov = coverage && coverage.length > 0;

      if (!hasDests && !hasArts && !hasCov) {
        list.innerHTML = '<div class="hp-hero__no-results">' +
          C.i18n('noResultsFor', { query: C.escapeHtml(query) }) +
          '<br><span style="font-size:0.8rem;color:#94a3b8;margin-top:4px;display:inline-block;">' + C.i18n('tryHint') + '</span>' +
          C.helpLinksHtml() + '</div>';
        if (footer) footer.style.display = 'none';
        // Track zero-result query → tells us which aliases to add next
        if (window.__SearchTracking && !isPopular && query) {
          window.__SearchTracking.zeroResults(query, 'hero');
        }
        open(); return;
      }

      /* Continent-level queries ("Europe", "Asia", "Middle East", 欧洲, アジア…)
         render REGION matches BEFORE specific country plans, because the
         user's intent is "browse this continent" — not "buy a specific
         country plan". Country-level queries keep Plan-first order
         (Plans are more directly actionable). */
      var continentPriority = !isPopular && hasDests && C.isContinentQuery && C.isContinentQuery(query, dests);

      var html = '';
      function appendCoverage() {
        if (!hasCov) return;
        var topBorder = continentPriority ? ' style="border-top:1px solid #f1f5f9;padding-top:0.5rem;margin-top:0.25rem;"' : '';
        html += '<div class="hp-hero__section-label"' + topBorder + '>' + C.i18n('sectionAvailable') + '</div>';
        coverage.forEach(function (p) { html += renderCoverageItem(p, query); });
      }
      function appendDests() {
        if (!hasDests) return;
        if (isPopular) {
          html += '<div class="hp-hero__section-label">' + C.i18n('sectionPopular') + '</div>';
        } else if (hasCov || hasArts) {
          // Border-top only when this section follows another; on continent-priority it's first, no border.
          var topBorder = continentPriority ? '' : ' style="border-top:1px solid #f1f5f9;padding-top:0.5rem;margin-top:0.25rem;"';
          html += '<div class="hp-hero__section-label"' + topBorder + '>' + C.i18n('sectionBrowseRegion') + '</div>';
        }
        dests.forEach(function (d) { html += renderDestItem(d, query); });
      }
      if (continentPriority) { appendDests(); appendCoverage(); }
      else { appendCoverage(); appendDests(); }

      if (hasArts) {
        html += '<div class="hp-hero__section-label" style="border-top:1px solid #f1f5f9;padding-top:0.5rem;margin-top:0.25rem;">' + C.i18n('sectionArticles') + '</div>';
        articles.forEach(function (a) {
          html += '<a href="' + C.localizeUrl(a.url || '#') + '" class="hp-hero__result-item">' +
            '<div class="hp-hero__result-image" style="display:flex;align-items:center;justify-content:center;font-size:1.25rem;background:#fef6e4;border-radius:8px;">\uD83D\uDCD6</div>' +
            '<div class="hp-hero__result-info"><p class="hp-hero__result-title hp-hero__result-title--blog">' + (query ? C.highlightMatch(a.title || '', query) : C.escapeHtml(a.title || '')) + '</p></div>' +
            arrow() + '</a>';
        });
      }

      if (list.innerHTML !== html) list.innerHTML = html;

      if (footer && footerLink) {
        if (query && !isPopular) {
          footerLink.href = C.localizeUrl('/search?q=' + encodeURIComponent(query) + '&type=product,article');
          footerLink.textContent = C.i18n('searchAllFor', { query: query });
        } else {
          footerLink.href = C.localizeUrl('/collections/esim');
          footerLink.textContent = C.i18n('browseAllDests');
        }
        footer.style.display = 'block';
      }
      open();
    }

    /* ---- Search orchestration ---- */
    function showPopular() {
      var isAU = window.location.pathname.toLowerCase().indexOf('/en-au') === 0;
      renderResults(C.getPopularDestinations(window.__GEO_COUNTRY, isAU), [], '', true);
    }

    function searchAll(query) {
      var destMatches = C.matchDestinations(query);
      var countryNames = C.getMatchedCountryNames(query);
      var coverage = C.findCoverageProducts(countryNames);
      var filtered = coverage.length > 0 ? destMatches.filter(function (d) { return d.type === 'region'; }) : destMatches;

      renderResults(filtered, [], query, false, coverage);

      /* City / landmark / regional name in ANY language should resolve to
         the country's Travel eSIM products. Shopify's /search/suggest.json
         indexes English product titles/tags only — so 东京 / 도쿄 / バリ
         / Roma / München / Marrakech all return 0 (or too few) products
         from the raw query. Our local matchDestinations() already mapped
         the query to a country; pass that English country name to Shopify
         so the user always sees the right country's eSIM products. */
      var shopifyQ = query;
      if (countryNames.length > 0) {
        // Skip substitution only if the user typed the country English name
        // verbatim (e.g. "japan" / "JAPAN") — Shopify will resolve it directly.
        var typedCountryDirectly = countryNames.some(function (n) {
          return n.toLowerCase() === query.toLowerCase();
        });
        if (!typedCountryDirectly) {
          shopifyQ = countryNames[0]; // e.g. "Japan", "France", "Italy"
        }
      }

      C.fetchShopifyResults(shopifyQ, fetchIdRef, function (products, articles, collections) {
        if (collections && collections.length > 0) {
          /* Dedup on the locale-stripped path: Shopify hands back
             '/en-au/collections/global-esims' while DESTINATIONS holds
             '/collections/global-esims', so the old `d.url === c.url` test
             never matched and "Global eSIM" rendered twice. */
          var seenDestKeys = {};
          filtered.forEach(function (d) { seenDestKeys[C.urlKey(d.url)] = true; });
          collections.forEach(function (c) {
            var collKey = C.urlKey(c.url);
            if (seenDestKeys[collKey]) return;
            seenDestKeys[collKey] = true;
            var flagCode = '_globe';
            var t = c.title.toLowerCase();
            for (var k in _collectionFlagMap) { if (t.indexOf(k) > -1) { flagCode = _collectionFlagMap[k]; break; } }
            filtered.push({ name: c.title, flag: flagCode, url: c.url, type: 'region' });
          });
        }
        C.updatePricesFromProducts(products);
        var pricesChanged = false;
        destMatches.forEach(function (dest) {
          if (C.priceCache[dest.name]) return;
          products.forEach(function (p) {
            if ((p.title || '').toLowerCase().indexOf(dest.name.toLowerCase()) === -1) return;
            var n = parseFloat(p.price);
            var ex = Infinity;
            if (C.priceCache[dest.name]) ex = parseFloat(C.priceCache[dest.name].replace(/[^\d.]/g, ''));
            if (n < ex) { C.priceCache[dest.name] = C.currencySymbol + n.toFixed(2); pricesChanged = true; }
          });
        });

        /* Fallback: if local COVERAGE_PRODUCT_INDEX is empty for this query
           but Shopify returned actual products, surface them as coverage
           cards so users see purchasable products in the dropdown (not just
           the country card). Critical for CJK/Korean/Arabic searches where
           the local metafield index may not exist but Shopify can match
           the English-translated query. */
        var coverageMerged = coverage.slice();
        if (coverageMerged.length === 0 && products && products.length > 0) {
          /* On this fallback path `filtered` still holds country rows (they are
             only stripped when the local coverage index answered), and a country
             row links straight to its product — so promoting the same product to
             a coverage card listed it twice, e.g. "Thailand" above "Thailand
             Prepaid Travel eSIM Card". */
          C.dedupeProducts(products, coverage, filtered).forEach(function (p) {
            if (!p || !p.handle || !p.title) return;
            // Convert Shopify product shape → coverage-card shape {h,t,p,i,c}
            var priceCents = Math.round((parseFloat(p.price) || 0) * 100);
            coverageMerged.push({
              h: p.handle,
              t: p.title,
              p: priceCents,
              i: (p.featured_image && p.featured_image.url) || p.image || '',
              c: 1 // single product, not a region
            });
          });
          coverageMerged = coverageMerged.slice(0, 6);
        }

        var shouldRender = pricesChanged
          || (coverageMerged.length > coverage.length)
          || (collections && collections.length > 0);
        // Hero search dropdown intentionally excludes Travel Guide articles
        // (only shows destinations + matching products). Articles are still
        // searchable via /search results page.
        if (shouldRender) renderResults(filtered, [], query, false, coverageMerged);
      });
    }

    /* ---- Event listeners ---- */
    if (form) {
      form.addEventListener('submit', function (e) {
        var active = list.querySelector('.hp-hero__result-item--active');
        if (active) { e.preventDefault(); window.location.href = active.href; return; }
        if (list.children.length > 0 && list.children[0].href) { e.preventDefault(); window.location.href = list.children[0].href; }
      });
    }

    input.addEventListener('input', function () {
      var q = this.value.trim();
      if (clearBtn) clearBtn.classList.toggle('is-visible', q.length > 0);
      // Keep submit button tappable on mobile even when input loses focus
      // (CSS hides .hp-hero__search-submit at <=480px unless form has focus
      // or input has content — JS class is the reliable fallback).
      if (form) form.classList.toggle('has-query', q.length > 0);
      if (q.length < 1) { showPopular(); return; }
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () { searchAll(q); }, C.DEBOUNCE_MS);
    });

    input.addEventListener('focus', function () {
      if (window.__loadCoverageIndex) window.__loadCoverageIndex();
      var q = this.value.trim();
      if (q.length === 0) showPopular();
      else if (list.innerHTML !== '') open();
      else searchAll(q);
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        input.focus();
        clearBtn.classList.remove('is-visible');
        if (form) form.classList.remove('has-query');
        showPopular();
      });
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.hp-hero__search')) close();
    });

    input.addEventListener('keydown', function (e) {
      var items = list.querySelectorAll('.hp-hero__result-item');
      if (e.key === 'Escape') { close(); input.blur(); return; }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        activeIndex += e.key === 'ArrowDown' ? 1 : -1;
        if (activeIndex < 0) activeIndex = items.length - 1;
        if (activeIndex >= items.length) activeIndex = 0;
        items.forEach(function (item, i) { item.classList.toggle('hp-hero__result-item--active', i === activeIndex); });
        if (items[activeIndex]) items[activeIndex].scrollIntoView({ block: 'nearest' });
        return;
      }
      if (e.key === 'Enter') {
        var active = list.querySelector('.hp-hero__result-item--active');
        if (active) { e.preventDefault(); window.location.href = active.href; }
        else if (items.length > 0) { e.preventDefault(); window.location.href = items[0].href; }
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
